/**
 * Builds initials from first and last names
 *
 * @param person - Customer, Agent, or Loan Officer object
 * @returns - Up to two uppercased initials, or undefined if no first or last name
 */
const getInitials = (
  person?: Customer | Agent | LoanOfficer,
): string | undefined => {
  if (!person) {
    return undefined;
  }

  const { firstname, lastname } = person;

  const initials = [firstname, lastname]
    .map((name) => name?.trim()?.charAt(0))
    .filter(Boolean)
    .join('')
    .toUpperCase();

  return initials || undefined;
};

export default getInitials;
